/* eslint jsx-a11y/no-static-element-interactions:0 */
import React from 'react';
import PropTypes from 'prop-types';

const ErrorNote = ({ raceType, raceTypeName, onReload }) => (
    <div>
        <h3 className="hp-notes__title">{raceTypeName}</h3>
        <div className="hp-notes__note">
            <div className="hp-notes__fieldSet">
                <label className="hp-notes__label" htmlFor={`${raceType}_note`}>
                    <span className="hp-notes__label_type">{raceTypeName}</span>
                        Note
                </label>
                <div className="hp-notes__input_container">
                    <div className="hp-notes__error">
                        There&apos;s a technical problem that means notes and ratings
                        content is currently unavailable. We are working to restore
                        the service as fast as possible and are sorry for any inconvenience
                        caused. Please click <span
                            onClick={onReload}
                            className="hp-notes__error__link"
                        >
                            here
                        </span> to refresh the page or try again later.
                    </div>
                </div>
            </div>
            <div className="hp-notes__fieldSetWrapper">
                <div className="hp-notes__fieldSet hp-notes__fieldSet_rating">
                    <label className="hp-notes__label" htmlFor={`${raceType}_rating`}>
                        Rating
                    </label>
                    <span className="ui-input hp-notes__input hp-notes__input_rating" />
                </div>
                <div className="hp-notes__fieldSet hp-notes__fieldSet_ratingFlag">
                    <label className="hp-notes__label" htmlFor={`${raceType}_ratingFlag`}>
                        +/-
                    </label>
                    <span className="ui-input hp-notes__input hp-notes__input_ratingFlag" />
                </div>
            </div>
        </div>
        <div className="ui-divider" />
    </div>
);

ErrorNote.propTypes = PropTypes.shape({
    raceType: PropTypes.string.isRequired,
    raceTypeName: PropTypes.string.isRequired,
    onReload: PropTypes.func.isRequired,
}).isRequired;

export default ErrorNote;



// WEBPACK FOOTER //
// ./src/js/horse/notes/components/ErrorNote.jsx